import React from 'react';

const MedalIcon = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "28",
    height: "28",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14 17.5002C18.3492 17.5002 21.875 14.105 21.875 9.91683C21.875 5.72867 18.3492 2.3335 14 2.3335C9.65076 2.3335 6.125 5.72867 6.125 9.91683C6.125 14.105 9.65076 17.5002 14 17.5002Z",
      fill: "#FFD300"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M18.4217 18.2114C18.8067 18.0131 19.25 18.3048 19.25 18.7364V24.3948C19.25 25.4448 18.515 25.9581 17.605 25.5264L14.4783 24.0448C14.21 23.9281 13.79 23.9281 13.5217 24.0448L10.395 25.5264C9.485 25.9464 8.75 25.4331 8.75 24.3831L8.77333 18.7364C8.77333 18.3048 9.22833 18.0248 9.60167 18.2114C10.92 18.8764 12.4133 19.2498 14 19.2498C15.5867 19.2498 17.0917 18.8764 18.4217 18.2114Z",
      fill: "#FFD300"
    }
  )
);
MedalIcon.displayName = "Icons.MedalIcon";

export { MedalIcon };
//# sourceMappingURL=MedalIcon.js.map
